import Cookies from 'universal-cookie';

const clientCookies = (typeof window !== 'undefined') ? new Cookies() : null;

export default clientCookies;
